import { CasesValue } from "../../../services/api/instances/casesApi/types";

export const getUpdatedCaseValue = (
  value: CasesValue,
  fields: Partial<CasesValue["case_object"]> = {},
): CasesValue => ({
  ...value,
  case_object: {
    ...value.case_object,
    ...fields,
  },
});
